<h2 mat-dialog-title>{{ 'LIB_ORDERS.SALES_ORDERS.CREATE_ORDER_SHORT' | translate }}</h2>
<mat-dialog-content>
  <div class="business-name">
    {{ data.business?.napData?.companyName }}
  </div>
  <div class="business-address">
    {{ data.business?.napData | formatAddress }}
  </div>

  <div class="selection-button" (click)="createNewOrder()">
    <div class="button-label">
      {{ 'LIB_ORDERS.SALES_ORDERS.CREATE_ORDER_DIALOG.CREATE_NEW_ORDER' | translate }}
    </div>
  </div>

  @if (data.order; as order) {
    <div class="selection-button" (click)="goToDraftOrder()">
      <div class="button-label">
        {{ 'LIB_ORDERS.SALES_ORDERS.CREATE_ORDER_DIALOG.OPEN_LAST_DRAFT' | translate }}
      </div>
      <div class="draft-order-details">
        <div class="order-id">{{ order.orderId }}</div>
        <div>
          {{
            'LIB_ORDERS.SALES_ORDERS.CREATE_ORDER_DIALOG.CONTRACT_START_DATE' | translate: { date: contractStartDate }
          }}
        </div>
      </div>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button color="secondary" (click)="close()">
    {{ 'LIB_ORDERS.COMMON.ORDERS.CANCEL' | translate }}
  </button>
</mat-dialog-actions>
